import { render } from "./InstructorProfile.vue?vue&type=template&id=534d5926&scoped=true"
import script from "./InstructorProfile.vue?vue&type=script&lang=js"
export * from "./InstructorProfile.vue?vue&type=script&lang=js"

import "./InstructorProfile.vue?vue&type=style&index=0&id=534d5926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534d5926"]])

export default __exports__